import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneSectionSettingPayload {
    settingId: string
    sectionName: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IOneSectionSettingState {
    status: string
    data: any
    errors: any
}

const initialState: IOneSectionSettingState = {
    status: STATUS.IDLE,
    data: {},
    errors: null
}

const oneSectionSetting = createSlice({
    name: 'event-setting/one-section',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneSectionSettingPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneSectionSettingActions = oneSectionSetting.actions
export default oneSectionSetting.reducer
